var $ = require('jquery')
  , tmpl = require('./tmpl.handlebars')
  , _ = require('underscore')

$(function() {
  /**
   * XXX: 猜你喜欢模块，包含推广位，原开发：黄见欢
   */
  var favorRecommend = {
    pageSize: 4,
    similarGamesArr: [],
    initialSimilarGamesArr: [],
    recommendData: {},
    isReseted : false,
    // 初始化方法，包括获取当前游戏类型、获取一个推广游戏数据、获取相似游戏数据、绑定元素事件
    init: function() {
      var ued = window.ued || {}
      this.gameType = ued.gameType;
      this.getRecommend();
      this.getSimilar();
      this.bindEvents();
      this.showList();
    },
    // 获取符合时间范围，且符合投放类型的推广数据，并随机选择一条在当前页显示
    getRecommend: function() {
      var rcmdList = window.favorRcmd || [], validData = [];
      for (var i = 0; i < rcmdList.length; i++) {
        var startDate = rcmdList[i].startDate;
        var endDate = rcmdList[i].endDate;

        if (this.dateBeforeNow(startDate) && this.dateAfterNow(endDate) && (!rcmdList[i].only_this_type || rcmdList[i].game_type_name == this.gameType )) {
          validData.push(rcmdList[i]);
        }
      }
      if (validData.length > 0) {
        this.recommendData = validData[parseInt(Math.random()*validData.length,10)];
        this.pageSize = 3;
      }
    },
    // 计算日期是否比当前早
    dateBeforeNow: function(dateStr) {
      return !dateStr || new Date(dateStr).getTime() <= new Date().getTime();
    },
    // 计算日期是否迟于当前日期
    dateAfterNow: function(dateStr) {
      return !dateStr || new Date(dateStr).getTime() >= new Date().getTime();
    },
    // 获取相似游戏数据，并剔除与推广游戏相同的数据
    getSimilar: function() {
      var ued = window.ued || {}
      this.similarGamesArr = ued.similarGamesArr || [];
      this.initialSimilarGamesArr = this.similarGamesArr.concat();
      if (!!this.recommendData.game_code) {
        for (var i = 0; i < this.similarGamesArr.length; i++) {
          if (this.similarGamesArr[i].game_code == this.recommendData.game_code) {
            this.similarGamesArr.splice(i, 1);
          }
        }
      }
      // 数组随机排序
      for (var i = this.similarGamesArr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = this.similarGamesArr[i];
        this.similarGamesArr[i] = this.similarGamesArr[j];
        this.similarGamesArr[j] = temp;
      }
    },
    // 渲染一条数据
    renderItem: function(item, isRecommend) {
      var isSy = false
        , platforms = item.game_platform
      for (var i = 0; i < platforms.length; i++) {
        if (platforms[i] == 'Android' || platforms[i] == 'IOS') {
          isSy = true;
          break
        }
      }

      var info = $.extend({
          logoPicture: item.show_pic || item.logo_pic || item.large_logo
        , hasStarLevel: !!item.star_level
        , starLevelPercent: item.star_level * 20
        , isSy: isSy
        , tags: _.map([
             'game_frame'
           , 'game_style'
           , 'game_theme'
           , 'game_type'
          ], function(tagName) {
            return {
                name: item[tagName + '_name']
              , url: item[tagName + '_url']
            }
          })
      }, item)

      if (!item.game_code) { return '' }

      return tmpl(info)
    },
    // 渲染整个列表
    showList: function() {
      var html = '', itemArr = [];
      // 先渲染推广数据
      if (!$.isEmptyObject(this.recommendData)) {
        html += this.renderItem(this.recommendData, true);
      }

      if(this.similarGamesArr.length > this.pageSize) {
        for (var l = 0; l < this.pageSize; l++) {
          html += this.renderItem(this.similarGamesArr[l]);
        }
        this.similarGamesArr.splice(0, this.pageSize);
        if (this.similarGamesArr.length <= this.pageSize) {
          this.isReseted = true;
        }
      } else {
        for (var i = 0; i < this.similarGamesArr.length; i++) {
          html+= this.renderItem(this.similarGamesArr[i]);
        }
        if (this.isReseted) {
          this.similarGamesArr = this.initialSimilarGamesArr.concat();
        }
      }

      $('.js-similar-list').empty().append(html);
    },
    // 绑定元素事件
    bindEvents: function() {
      var self = this;
      $('.js-similar-list').show();
      if (this.similarGamesArr.length > this.pageSize) {
        $('.js-refresh-similar').click(function() {
          self.showList();
        });
      } else {
        $('.js-refresh-similar').hide();
      }
    }
  };
  favorRecommend.init();
})
